import React from 'react';
import moment from 'moment';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const PatchNotes = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      {!props.client.patch_test_date && (
        <div className="client-information block cfix">
          <span className="font-16">{t('composite.clientProfile.notes.title')}</span>
          <span className="font-16" style={{ opacity: 0.4 }}>
            {t('composite.clientProfile.notes.noPatchBooked')}
          </span>
          <button className="btn btn-violet-link" onClick={props.goToPatchView}>
            {t('composite.clientProfile.notes.addNoteButton')}
          </button>
        </div>
      )}

      {props.client.patch_test_date && (
        <div className="client-information block cfix">
          <span className="font-16">
            {t('composite.clientProfile.notes.title')}
            {S.space}
            {props.client.patch_test_date ? moment(props.client.patch_test_date).format('DD MMMM YYYY') : ''}
          </span>

          <span role="button" tabIndex="0" className="btn btn-violet-link" onClick={props.goToPatchView}>
            {t('composite.clientProfile.notes.editButton')}
          </span>

          <span className="font-16">
            <i>
              {S.space}
              {props.client && props.client.patch_test_notes
                ? props.client.patch_test_notes
                : t('composite.clientProfile.notes.noNote')}
              .
            </i>
          </span>
        </div>
      )}
    </div>
  );
};

export default PatchNotes;
